<template>
  <div class="main">

    <div class="company-info">

        <a-descriptions bordered>
            <a-descriptions-item label="企业名称">{{detail.companyName}}</a-descriptions-item>
            <a-descriptions-item label="入库编号">{{detail.warehousingCode}}</a-descriptions-item>
            <a-descriptions-item label="企业地址">{{ detail.companyCode }}</a-descriptions-item>
            <a-descriptions-item label="生效年份">{{ detail.takeTime }}</a-descriptions-item>
        </a-descriptions>
      <p style="text-align: center;margin-top:20px;"><button @click="goBack" class="custom-button">返回</button></p>
    </div>
  </div>
</template>

<script>
import {dictMixin, getDistMixin, listMixin} from "@/mixins";
import {file_service, login_mp, sys_admin, sys_policyNotice} from "@/api/adminService";
import {ls} from "@/utils/util"
import {enterpriseOperatingIncome} from "@/api/integral";
import {getBannerInfo, getWebInfo, noticeInfo} from "@/api/homeService";
import {platformName} from "@/config/platformConfig";

export default {
  name: "highEnterpriseDetail",
  components: {
  },
  mixins: [dictMixin, getDistMixin, listMixin],
  data() {
    return {
        detail:{...this.$route.query},
      sizes: 16,
      dictNames: 'policy_type',
      noticeData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      visible: false,
      getDateId: null,
      formState: {
        user: undefined,
      },
      noticeObj: {},
      bannerData: [],
      webSiteInfo: {},
      linkData: [],
      source: '',
      queryParam: {},
      listUrl: noticeInfo.pageList,
      current: 1,
      pageSize: 10,
      str: null
      // selectOption: [
      // 	{ label: '种子期(0（含）—100万元)', value: 1 },//seed
      // 	{ label: '初创期(100（含）—500万元)', value: 2 },//newly
      // 	{ label: '成长期(500（含）—2000万元)', value: 3 },//growth
      // 	{ label: '成熟期(2000（含）以上万元)', value: 4 }, //maturation
      // ],
    }
  },
  methods: {
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goMorePolicy() {
      this.$router.push({
        path: '/notice',
        // query: { type: "资讯公告", activeKey: 2 }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    getUserInfo() {
      this.getAction({
        url: sys_admin.userInfor
      }).then(res => {
        sessionStorage.setItem("roleCode", res.roleCode.split(','));
      })
    },
    goHttp(url) {
      window.open(url, '_bank')
    },
    goMore(url, str) {
      this.$router.push({ path: url, query: { id: str } })
    },
    goMoreNotice(url, str) {
      console.log('url: ', url, str)
      this.$router.push({ path: url, query: { ...str } })
    },
    getDetail() {
      if (this.$route.query.type == 1) {
        this.getAction({
          url: sys_policyNotice.detail,
          params: { id: this.$route.query.id }
        }).then(res => {
          this.noticeObj = res
        })
      } else {
        this.getAction({
          url: noticeInfo.noticeDetail,
          params: { id: this.$route.query.id }
        }).then(res => {
          this.noticeObj = res
        })
      }
    },
    getPolicyNotice() {
      this.getAction({
        url: sys_policyNotice.detail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.noticeObj = res
      })
    },
    goNoticeList() {
      if (this.$route.query.source == 'piao') {
        this.$router.push({
          path: '/notice',
          query: { source: 'piao' }
        })
      } else {
        this.$router.push({
          path: '/notice',
          query: { type: this.str }
        })
      }
    },
    getDate() {
      this.getAction({
        url: enterpriseOperatingIncome.getDate,
        // params: { id: id },
        returnMsg: true,
      }).then((res) => {
        this.getDateId = res.data
        // auditStatus
      });
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'home' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getWebInfo() {
      this.getAction({
        url: getWebInfo.detail,
        params: { id: 1 }
      }).then(res => {
        this.webSiteInfo = res
      })
    },
  },
  mounted() {
    this.str = this.$route.query.type
    this.getWebInfo()
    this.getBannerList()
    // this.getDate()
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
    this.source = this.$route.query.source
    if (this.$route.query.source == 'piao') {
      this.getPolicyNotice()
    } else {
      this.getDetail()
    }
  }
}
</script>

<style scoped lang="less">

.main{
  width: 100%;
  padding:20px;
  height:100vh;background-color: #fff;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  .custom-button {
    border: none;
    margin:0 auto;
    background-color: #ff6600;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    font-size: 16px;
  }

  .custom-button:hover {
    background-color: #ff8533;
  }
  }
:deep(.ant-btn) {
  color: #fc550b;
  font-weight: 600;
  padding: 0 10px;

  img {
    margin-right: 5px
  }

  &:hover {
    border-color: #ffffff;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }
}


:deep(.ant-list-lg .ant-list-item) {
  padding: 16px 8px;
}
</style>
